import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const sections = [
  { id: 'hero', label: 'Hero' },
  { id: 'features', label: 'Features' },
  { id: 'training', label: 'Training' },
  { id: 'clubs', label: 'Clubs' },
  { id: 'results', label: 'Results' },
  { id: 'faq', label: 'FAQ' },
  { id: 'sign-in', label: 'Sign In' },
];

export function ScrollProgressDots() {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
    );

    sections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className="fixed right-4 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col items-end gap-3">
      {sections.map((s) => (
        <button
          key={s.id}
          onClick={() => scrollTo(s.id)}
          className="group flex items-center gap-2"
          aria-label={`Go to ${s.label}`}
        >
          <span className={cn(
            "text-[10px] font-medium opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground",
          )}>
            {s.label}
          </span>
          <span className={cn(
            "block rounded-full transition-all",
            activeSection === s.id
              ? "w-2.5 h-2.5 bg-primary"
              : "w-1.5 h-1.5 bg-muted-foreground/40 group-hover:bg-muted-foreground"
          )} />
        </button>
      ))}
    </nav>
  );
}
